export default "__VITE_ASSET__859d8eda__"